import dictionary from "../constants/dictionary";

export const t = (dictionaryKey) => dictionary[dictionaryKey] || dictionaryKey;
